import { createSlice } from "@reduxjs/toolkit";
import initialState from "./state";
import { fetchBom, fetchOptions } from "./actionCreator";

export const inventoryReportsTitleBarSlice = createSlice({
  name: "inventoryReportsTitleBar",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    /*-------------------------------- get share drive Pending State ---------------------------------*/
    builder.addCase(fetchOptions.pending, (state) => {
      state.companies = [];
      state.items = [];
      state.warehouseLocations = [];
      state.assemblyItems = []
      state.isLoading = true;
      state.error = "";
    });
    builder.addCase(fetchOptions.fulfilled, (state, action) => {

      state.companies = action.payload?.c;
      state.items = action.payload?.i;
      state.warehouseLocations = action.payload?.wl;
      state.assemblyItems = action.payload?.ai;
      state.isLoading = false;
      state.isError = false;
      state.error = "";

    });
    builder.addCase(fetchOptions.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message || "";
      state.isError = true;
    });
    builder.addCase(fetchBom.fulfilled, (state, action) => {
      state.bomData = action.payload?.bom;
    });
  },
});

export default inventoryReportsTitleBarSlice.reducer;
